<div #topOfProductList></div>

<!-- WHILE LOADIN -->
@if (!noProductsFound && (!productTabs || displaySpinner)) {
  <div class="no-data">
    <span>Please wait while we find plans for your location...</span>
    <mat-spinner></mat-spinner>
  </div>
}

<!-- POST-LOAD:  NO DATA -->
@if (noProductsFound) {
  <div class="no-data">
    <div [innerHTML]="errorMessageSanitized"></div>
  </div>
}

<!-- BEFORE LOAD / POST-LOAD:  HAS DATA -->
@if (!noProductsFound && !displaySpinner) {
  <mat-tab-group mat-align-tabs="center"
    (selectedTabChange)="productChanged($event)" [selectedIndex]="selectedTab.value"
    (selectedIndexChange)="selectedTab.setValue($event)">
    @for (productTab of productTabs; track productTab) {
      <mat-tab
        label="{{ productConfigs.get(productTab)?.productTabLabel || productTab }}">
        <ng-template mat-tab-label>
          <div class="product-tab">
            @if (getImageForProductType(productTab)) {
              <img [attr.src]="getImageForProductType(productTab)" [attr.alt]="">
            }
            <div class="label-content">
              <p>
                {{ productConfigs.get(productTab)?.productTabLabel || productTab}}
                @if (productConfigs.get(productTab).showTabNumber) {
                  <span>
                    ({{ products?.get(productTab)?.length !== 0 ? filteredAmount(productTab) : '?'}})
                  </span>
                }
              </p>
            </div>
          </div>
        </ng-template>
        <section class="plan-summary-list-container">
          <!-- PRODUCT TAB SPECIFIC CONTENT & FORM REFRESH -->
          <div class="product-content-container">
            @if (productTabs.length > 1) {
              <h2 class="product-type-info">{{productTab}}</h2>
            }
            <slot name="{{productConfigs.get(productTab)?.slotName}}">{{productTab}} Content</slot>
            <!-- FORM REFRESH -->
            @if (!productConfigs.get(productTab)?.showForm && productConfigs.get(productTab)?.formConfigStrategy) {
              <p>
                {{ productConfigs.get(productTab)?.showFormDescription || 'To show accurate cost and eligibility' }}
                <a href="javascript:void(0)" (click)="showForm(productTab, null, formToShow)" class="plans-toggle">
                  {{ productConfigs.get(productTab)?.showFormLinkLabel || 'we need your details.' }}
                </a>
              </p>
            }
          </div>
          <!-- FORM DISPLAY:  START -->
          @if (shouldShowForm(productTab)) {
            <div>
              <app-load-form [formConfigStrategy]="productConfigs.get(productTab)?.formConfigStrategy">
                <!-- [byfAemInputs]="byfAemInputs" -->
              </app-load-form>
            </div>
          }
          <!-- FORM DISPLAY:  ERROR + RESET -->
          @if (formError && productConfigs.get(productTab)?.formError) {
            <div class="product-content-container">
              <div class="no-data">
                <span class="warning-box"
                [innerHtml]="getSanitizedHTMLContent(productConfigs.get(productTab)?.formError)"></span>
              </div>
            </div>
          }
          <div class="filters">
            <!-- ATTRIBUTE FILTERS -->
            @if (showFiltersBool) {
              <div class="plan-filter-container">
                <app-plan-filter
                  (filtersChanged)="rebuildPriceSlider()"
                ></app-plan-filter>
              </div>
            }
            <!-- PRICE SLIDER -->
            @if ((
              !productConfigs.get(productTab).showForm &&
              priceSliderConfig?.get(productTab)?.options &&
              priceSliderConfig?.get(productTab)?.showSlider
              )) {
              <div class="slider-container">
                <app-plan-price-slider #slider [id]="productTab" [plans]="products?.get(productTab)"
                  [options]="priceSliderConfig?.get(productTab)?.options"
                  (valuesChanged)="priceSliderValuesChanged($event, productTab)">
                </app-plan-price-slider>
              </div>
            }
            @if (showSaveQuoteButton) {
              <app-save-quote-button
                [showSaveQuoteButton]="showSaveQuoteButton"
                [quoteButtonPage]="quoteButtonPage"
                [enrollmentFlow] = "enrollmentFlow"
                [saveQuoteText]="saveQuoteText"
                [returnUrl]="returnUrl">
              </app-save-quote-button>
            }
            <!-- APTC (ONX) -->
            @if (!productConfigs.get(productTab).showForm) {
              <div class="slider-container tax-credit-slider">
                <app-advance-premium-tax-credit-slider></app-advance-premium-tax-credit-slider>
              </div>
            }
            <!-- PAGINATOR -->
            @if (showPaginatorBool && !noProductsFound) {
              <div class="paginator-container">
                <app-plan-summary-list-paginator></app-plan-summary-list-paginator>
              </div>
            }
          </div>
          <!-- PLAN CARDS -->
          @if (!productConfigs.get(productTab).showForm) {
            <div class="plans">
              @for (plan of products?.get(productTab)
                | price:priceSliderConfig.get(productTab)?.planMin:priceSliderConfig.get(productTab)?.planMax
                | planSorter:productOrder:recommendedPlanIds
                | planFilter:productTab
                | planDataSorter
                | planSummaryListPaginator; track trackByProductId($index, plan)) {
                <app-plan-card
                  [recommendedPlansUrl]="recommendedPlansUrl"
                  [recommendedPlanLabelOne]="recommendedPlanLabelOne"
                  [recommendedPlanLabelTwo]="recommendedPlanLabelTwo"
                  [recommendedPlanLabelThree]="recommendedPlanLabelThree"
                  [plan]="plan"
                  [enrollStartUrl]="plan.enrollStartUrl || enrollStartUrl"
                  [specialEnrollmentUrl]="specialEnrollmentUrl"
                  [planDetailsUrl]="planDetailsUrl"
                  [addMedicationsUrl]="addMedicationsUrl"
                  [numCheckboxesChecked]="comparePlansCheckboxLimitSubject.asObservable()"
                  [priceTooltip]="priceTooltip"
                  [starsTooltip]="starsTooltip"
                  [isSep]="isSep"
                  [planCardImageUrl]="planCardImageUrl"
                  [planCardImageLabel]="planCardImageLabel"
                  [planCardImageMatchers]="planCardImageMatchers"
                  [showCompareCheckbox]="products?.get(productTab)?.length > 1"
                  [disableCoverageDetails]="disableCoverageDetails"
                  (checkboxToggle)="comparePlanToggle($event)"
                  (showFormTrigger)="showForm(productTab, formToShow, $event)">
                </app-plan-card>
              }
            </div>
          }
        </section>
      </mat-tab>
    }
  </mat-tab-group>
}

<!-- COMPARE PLANS TOOLBAR -->
@if (comparablePlanIds?.length > 1) {
  <mat-toolbar class="compare-plans-hover">
    <span style="color: white; font-size: 16px;">Select up to 3 Plans: &nbsp;</span>
    <button mat-raised-button color="primary" (click)="goToComparePlans()">
      COMPARE PLANS
    </button>
  </mat-toolbar>
}
